import { useEffect } from "react";

function Socket({ socket, mandantId, onMessage, shop, settings, config }) {
	useEffect(() => {
		console.log("add socket listener");
		socket.on("connect", onConnectEvent);
		socket.on("disconnect", onDisconnect);
		socket.on("subscribed", onSubrscribed);
		socket.on("events", onSocketEvents);

		onConnect();

		return () => {
			console.log("remove socket listener");
			socket.off("connect", onConnectEvent);
			socket.off("disconnect", onDisconnect);
			socket.off("subscribed", onSubrscribed);
			socket.off("events", onSocketEvents);
		};
	}, [shop, settings, config]);

	// evento "connect" reale (anche riconnessioni): oltre a sottoscriversi, avvisa l'app
	function onConnectEvent() {
		onConnect();
		onMessage("socket_connected", null);
	}

	function onConnect() {
		console.log("Socket connected", socket.id);
		const hostname = window.location.hostname;
		let socketMandantId = mandantId;
		if (hostname.includes("localhost")) socketMandantId += "_localhost";
		if (hostname.includes(".demo.")) socketMandantId += "_demo";
		socket.emit("subscribe", "m" + socketMandantId + ".settings.#");
		socket.emit("subscribe", "m" + socketMandantId + ".menu.#");
		socket.emit("subscribe", "m" + socketMandantId + ".shops.#");
		socket.emit("subscribe", "m" + socketMandantId + ".products_stock.#");
		socket.emit("subscribe", "m" + socketMandantId + ".thermal_printers.#");
		socket.emit("subscribe", "m" + socketMandantId + ".s" + shop.id + ".tables.#");
		socket.emit("subscribe", "m" + socketMandantId + ".s" + shop.id + ".orders.#");
		if (config.mode == "local")
			socket.emit("subscribe", "m" + socketMandantId + ".cloudStatus");
	}

	function onDisconnect() {
		console.log("Socket disconnected");
	}

	function onSubrscribed(data) {
		console.log(data);
	}

	function onSocketEvents(message) {
		console.log("new socket event: ", message);
		onMessage(message.table, message.data);
	}

	return null;
}

export default Socket;
